var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainApp"},[_c('DealsPage',{ref:"deals_page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }